import * as React from "react";
import { strings, AllLocales, supportedLocales } from "./strings";
import { IntlProvider as LibIntlProvider } from "react-intl";

export interface IntlProps {
  locale: supportedLocales;
  onLocaleChange: (locale: supportedLocales) => void;
}

const { Provider, Consumer } = React.createContext<IntlProps>({
  locale: supportedLocales["en-gb"],
  onLocaleChange: (_: supportedLocales) => undefined
});

interface Props {
  children: React.ReactChild;
}

interface State {
  locale: supportedLocales;
  strings: AllLocales;
}

export class IntlProvider extends React.Component<
  Props,
  State
  > {
  constructor(props: Props) {
    super(props);
    // hack: localstorage should be done on start and via store subscription
    const defaultValue = (localStorage.getItem("myData") || "en-gb") as keyof typeof supportedLocales;
    const locale = supportedLocales[defaultValue];
    this.state = {
      locale,
      strings
    };
  }
  public render() {
    const locale = this.state.strings[this.state.locale];
    return (
      <Provider value={{ onLocaleChange: this.onLocaleChange, locale: this.state.locale }}>
        <LibIntlProvider locale={this.state.locale} messages={locale}>
          {this.props.children}
        </LibIntlProvider>
      </Provider>
    );
  }
  private onLocaleChange = (locale: supportedLocales) => {
    this.setState({
      locale
    });
    // hack: use redux and dispatch.
    localStorage.setItem("myData", locale);
  }
}

export const IntlConsumer = Consumer;

export function withIntl<T extends IntlProps>(WrappedComponent: React.ComponentType<T>) {
  type TWithoutIntl = Pick<T, Exclude<keyof T, keyof IntlProps>>;
  return (props: TWithoutIntl) => {
    return (<IntlConsumer>
      {state => {
        const newProps = { ...props, ...state } as T;
        return (<WrappedComponent {...newProps} />);
      }
      }
    </IntlConsumer>);
  };
}
